import Swal from "sweetalert2";
import apiConnection from "../../Connection";
import { clearCatalog, clearCatalogEdit, processRequest, setCatalog, setError } from "./slice";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


let dat = new Date();
let d = dat.getDate();
let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d

// Funciones generales
export const clearCatalogMemory = () => {
    return (dispatch, getState) => {
        dispatch(clearCatalog());
        dispatch(clearCatalogEdit());

    }
}

//---  Categorias - Categories - Categorias ---//
export const loadCategories = () => {
    return async (dispatch, getState) => {
        dispatch(clearCatalog());
        dispatch(processRequest());
        await apiConnection.get(`/Catalogs/getCategoriesInv`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setCatalog({
                        msg: 'Listado de Categorias cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const newCategories = (data) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.post(`/Catalogs/postCategories`, {
            NAMECATEGORY: data.nombreCategoria,
            DESCRIPTIONS: data.descripcionCategoria,
            CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Categoria registrada...'
                })
                dispatch(loadCategories());
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la categoria... favor de intentar de Nuevo'
            })
            dispatch(loadCategories());
            return;
        });

    }
}

export const editCategories = (data, id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putCategories/${id}`, {
            NAMECATEGORY: data.nombreCategoria,
            DESCRIPTIONS: data.descripcionCategoria,
            // CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Categoria actualizada...'
                })
                dispatch(loadCategories());
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo la categoria... favor de intentar de Nuevo'
            })
            dispatch(loadCategories());
            return;
        });

    }
}

export const deactivateCategory = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putDeactivateCategories/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Categoria desactivada...'
                })
                dispatch(loadCategories())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible desactivar la Categoria, favor de intentar de nuevo...'
                })
                dispatch(loadCategories());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible desactivar la Categoria, favor de intentar de nuevo...'
            })
            dispatch(loadCategories());
            console.log(error);
            dispatch(setError());
        });
    }
}

export const activateCategory = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putActivateCategories/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Categoria Activada...'
                })
                dispatch(loadCategories())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible activar la Categoria, favor de intentar de nuevo...'
                })
                dispatch(loadCategories());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible activar la Categoria, favor de intentar de nuevo...'
            })
            dispatch(loadCategories());
            console.log(error);
            dispatch(setError());
        });
    }
}

//--- Marcas - Brands - Brands - Marcas ---//
export const loadBrands = () => {
    return async (dispatch, getState) => {
        dispatch(clearCatalog());
        dispatch(processRequest());
        await apiConnection.get(`/Catalogs/getBrands`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setCatalog({
                        msg: 'Listado de Marcas cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError)
        });
    }
}

export const newBrand = (data) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.post(`/Catalogs/postBrands`, {
            NAMEBRAND: data.nombreMarca,
            DESCRIPTIONS: data.descripcionMarca,
            CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Marca registrada...'
                })
                dispatch(loadBrands());
            }
        }).catch(function (error) {
            // console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la marca... favor de intentar de Nuevo'
            })
            dispatch(loadBrands());
            return;
        });

    }
}

export const editBrand = (data, id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putBrand/${id}`, {
            NAMEBRAND: data.nombreMarca,
            DESCRIPTIONS: data.descripcionMarca,
            // CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Categoria actualizada...'
                })
                dispatch(loadBrands());
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo la categoria... favor de intentar de Nuevo'
            })
            dispatch(loadBrands());
            return;
        });

    }
}

export const deactivateBrand = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putDeactivateBrand/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Marca desactivada...'
                })
                dispatch(loadBrands())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible desactivar la Marca, favor de intentar de nuevo...'
                })
                dispatch(loadBrands());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible desactivar la Marca, favor de intentar de nuevo...'
            })
            dispatch(loadBrands());
            console.log(error);
            dispatch(setError);
        });
    }
}

export const activateBrand = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putActivateBrand/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Marca Activada...'
                })
                dispatch(loadBrands())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible activar la Marca, favor de intentar de nuevo...'
                })
                dispatch(loadBrands());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible activar la Marca, favor de intentar de nuevo...'
            })
            dispatch(loadBrands());
            console.log(error);
            dispatch(setError);
        });
    }
}

//--- Proveedores - Suppliers - Proveedores ---//
export const loadSuppliers = () => {
    return async (dispatch, getState) => {
        dispatch(clearCatalog());
        dispatch(processRequest());
        await apiConnection.get(`/Catalogs/getSuppliers`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setCatalog({
                        msg: 'Listado de Proveedores cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError)
        });
    }
}

export const newSupplier = (data) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.post(`/Catalogs/postSuppliers`, {
            RFC: data.rfcProveedor,
            NAMESUPPLIER: data.nombreProveedor,
            WEB: data.webProveedor,
            CONTACT: data.contactProveedor,
            PHONE: data.phoneProveedor,
            EMAIL: data.emailProveedor,
            ADDRESS: data.addressProveedor,
            CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Proveedor registrado...'
                })
                dispatch(loadSuppliers());
            }
        }).catch(function (error) {
            // console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro al Proveedor... favor de intentar de Nuevo'
            })
            dispatch(loadSuppliers());
            return;
        });

    }
}


export const editSupplier = (data, id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putSupplier/${id}`, {
            RFC: data.rfcProveedor,
            NAMESUPPLIER: data.nombreProveedor,
            WEB: data.webProveedor,
            CONTACT: data.contactProveedor,
            PHONE: data.phoneProveedor,
            EMAIL: data.emailProveedor,
            ADDRESS: data.addressProveedor,
            // CREATED_AT: fechaRegistro,
            UPDATED_AT: fechaRegistro,
            ACTIVE: 1
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Proveedor actualizado...'
                })
                dispatch(loadSuppliers());
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo al Proveedor... favor de intentar de Nuevo'
            })
            dispatch(loadSuppliers());
            return;
        });

    }
}

export const deactivateSupplier = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putDeactivateSupplier/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Proveedor desactivado...'
                })
                dispatch(loadSuppliers())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible desactivar al Proveedor, favor de intentar de nuevo...'
                })
                dispatch(loadSuppliers());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible desactivar al Proveedor, favor de intentar de nuevo...'
            })
            dispatch(loadSuppliers());
            console.log(error);
            dispatch(setError);
        });
    }
}

export const activateSupplier = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Catalogs/putActivateSupplier/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Proveedor Activado...'
                })
                dispatch(loadSuppliers())
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible activar al Proveedor, favor de intentar de nuevo...'
                })
                dispatch(loadSuppliers());
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible activar al Proveedor, favor de intentar de nuevo...'
            })
            dispatch(loadSuppliers());
            console.log(error);
            dispatch(setError);
        });
    }
}
